import { atom } from 'recoil';

const drawerOpenState = atom({
  key: 'drawerState',
  default: false,
});

export default drawerOpenState;
